import {
  Flex,
  FormControl,
  Select,
  SelectProps,
  Text,
  useColorModeValue,
  InputGroup,
  InputLeftElement,
} from '@chakra-ui/react';
import React from 'react';

interface Options {
  value: any;
  label: any;
}

interface InputSelectorProps extends SelectProps {
  label?: string;
  color?: string;
  bg?: string;
  labelColor?: string;
  error?: any;
  leftIcon?: React.ReactNode;
  options: Options[] | any;
  value?: any;
  disableSelecione?: boolean;
}

export default function InputSelector({
  label,
  labelColor,
  bg,
  error,
  leftIcon,
  value,
  options,
  disableSelecione,
  ...rest
}: InputSelectorProps) {
  // const textColor = useColorModeValue('black', 'white');
  const errorColor = useColorModeValue('rgb(155, 0, 0)', 'rgb(250, 100, 100)');
  const colorIcon = useColorModeValue('blue.500', 'white');
  const color = useColorModeValue('gray.800', 'gray.100');

  return (
    <FormControl width="100%" flex={1}>
      <Flex
        direction="column"
        bg={bg}
        borderRadius="2xl"
        borderWidth={leftIcon ? '1px' : '0px'}
        _focusWithin={{
          borderColor: 'blue.400',
          boxShadow: 'blue.400',
        }}
      >
        {label && (
          <Text
            color={labelColor}
            fontSize="18px"
            fontWeight="medium"
            left="8px"
          >
            {label}
          </Text>
        )}
        <InputGroup rounded="2x1" w="100%">
          {leftIcon && (
            <InputLeftElement
              display="flex"
              justifyContent="center"
              pointerEvents="none"
              color={colorIcon}
              h="100%"
              mr={2}
              ml={2}
            >
              {leftIcon}
            </InputLeftElement>
          )}

          <Select
            // placeholder=""
            value={value ?? ''}
            pl={leftIcon ? 10 : 0}
            borderWidth={leftIcon ? '0px' : '1px'}
            borderColor={error ? errorColor : 'inherit'}
            // aria-label={label}
            color={color}
            size="md"
            sx={{
              '&:focus': {
                boxShadow: 'none',
                outline: 'none',
              },
            }}
            {...rest}
          >
            {!disableSelecione && <option value=""> Selecione </option>}
            {options?.map((op: any) => (
              <option key={op.value} value={op.value}>
                {op.label}
              </option>
            ))}
          </Select>
        </InputGroup>
        {error && (
          <Text color={errorColor} fontSize={13} mt={1}>
            {error.message}
          </Text>
        )}
      </Flex>
    </FormControl>
  );
}
